
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3faab7b4&scoped=true!sass-loader?{\"api\":\"modern\",\"sassOptions\":{\"quietDeps\":true},\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ChordDiagramverbal.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ChordDiagramverbal.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3faab7b4!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChordDiagramverbal.vue"),
  /* scopeId */
  "data-v-3faab7b4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/dataVisualization/d3js/ChordDiagramverbal.vue
// module id = 1795
// module chunks = 61